
<template>
  <div
    v-if="visible"
    data-test="cloze-dropdown-question"
  >
    <div
      v-html="flashcardTemplate"
    >
    </div>
    <select
      v-for="(item, index) in dropDowns"
      :id="dropdownIdentifier(index)"
      :ref="dropdownIdentifier(index)"
      :key="dropdownIdentifier(index)"
      :data-test="dropdownIdentifier(index)"
      @change="handleDropdownChange(index)"
    >
      <option value="">
        Select
      </option>
      <option
        v-for="option in item"
        :key="option.id"
        :value="option.id"
        :selected="answerIds.includes(option.id)"
        :data-test="`answer-choice-${option.id}`"
      >
        {{ option.content }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  computed: {
    answerIds() {
      return this.flashcardState?.answerIds || [];
    },
    dropDowns() {
      let result = {};
      for( let answer of this.flashcard.answers ) {
        if( !result[answer.dropDownIdentifier]) {
          result[answer.dropDownIdentifier] = [];
        }
        result[answer.dropDownIdentifier].push(answer);
      }
      const keys = Object.keys(result);
      keys.forEach((key) => {
        result[key] = result[key].sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        });
      });
      return result;
    },
    numAnswers() {
      return Object.keys(this.dropDowns).length || 0;
    },
    flashcardTemplate() {
      let template = this.flashcard.question;

      this.flashcard.question.match(/\{\{[^\}]+\}\}/g).forEach( (match) => {
        const identifier = match.replace(/[\{\}\s]/g, '');
        const m = RegExp(`\{\{ *${identifier} *\}\}`);
        template = template.replace(m, `<span id="container-${identifier}"></span>`);
      });

      return template;
    },
  },
  watch: {
    async $route(to, from) {
      // this are about to get a little weird
      this.visible = false;
      await this.$nextTick();
      this.visible = true;
      await this.$nextTick();
      this.arrangeDropdowns();
    },
  },
  mounted() {
    this.$nextTick(this.arrangeDropdowns);
  },
  methods: {
    arrangeDropdowns() {
      const keys = Object.keys(this.dropDowns);
      keys.forEach((key) => {
        const dropdownIdentifier = `dropdown-${key}`;
        const containerIdentifier = `container-${dropdownIdentifier}`;
        const dropdownElement = document.getElementById(dropdownIdentifier);
        const containerElement = document.getElementById(containerIdentifier);
        if( dropdownElement && containerElement ) {
          if( dropdownElement.parentNode !== containerElement ) {
            containerElement.appendChild(dropdownElement);
          }
        }
      });
    },
    dropdownKey(index) {
      return `${this.flashcard.id}-dropdown-${index}`;
    },
    dropdownIdentifier(index) {
      return `dropdown-${index}`;
    },
    handleDropdownChange() {
      this.$emit('answers-selected', this.getSelectedAnswerIds());
    },
    getSelectedAnswerIds() {
      const keys = Object.keys(this.dropDowns);
      let ids = [];
      keys.forEach((key) => {
        const dropdownIdentifier = `dropdown-${key}`;
        const dropdownElement = this.$refs[dropdownIdentifier][0];
        const selectedAnswerId = dropdownElement.value;
        ids[key] = selectedAnswerId;
      });

      ids = ids.filter( id => {
        return id;
      });
      ids = ids.map( id => parseInt(id));
      return ids;
    },
  },
};
</script>

<style lang='scss'>
.stem {
  line-height: 1.75;
}
</style>
